module.exports = __webpack_public_path__ + "media/images/xpass/markers/active/clubpilates-4995755bb3d2654f43f24a0b329a2a0f.png";